import React from "react";
import styled from "styled-components";

/**
 * Out of stock message
 *
 * @returns {Object}
 */
export default function OutOfStockMessage() {
  return (
    <Message>
      This product is currently out of stock.
    </Message>
  );
}
const Message = styled.div`
  color: #E00425;
  font-weight: bold;
  text-align: left;
  padding: 3px 12px;
  border: 1px solid #E00425;
`;
